import config from './config.js';

class IRNewsConfig {
  /** 言語コード */
  lang = 'ja';

  /** 設定データ */
  data = null;

  constructor(data) {
    this.lang = this.getLang();
    this.data = data;
  }

  /**
   * @return {String} 言語コード
   */
  getLang() {
    return document.documentElement.lang || 'ja';
  }

  /**
   * @return {Object} API送信用のパラメータ
   */
  getApiParams() {
    return {
      company: this.data.api.company,
      output: this.data.api.output
    };
  }

  /**
   * @return {String} APIのルートURL
   */
  getApiRoot() {
    return this.data.api.domain + this.data.api.path;
  }

  /**
   * @return {Number} 記事リストの数
   */
  getLen() {
    return this.data.len;
  }

  /**
   * @return {Object} 種別データ
   */
  getDoctypes() {
    return this.data.doctypes;
  }

  /**
   * @param {String} doctypePropName 種別プロパティ名
   * @return {Array} 種別IDの配列
   */
  getDoctypeIds(doctypePropName) {
    if (!doctypePropName || doctypePropName === 'all') {
      const doctypes = this.getDoctypes();
      const ids = [];
      for (const propName of Object.keys(doctypes)) {
        if (propName !== 'all') {
          ids.push(doctypes[propName].ids);
        }
      }
      return ids.flat();
    } else {
      return this.getDoctype(doctypePropName)?.ids || [];
    }
  }

  /**
   * 種別設定の取得
   * @param {String} doctypePropName 種別プロパティ名
   * @return {Object} 種別設定オブジェクト
   */
  getDoctype(doctypePropName) {
    const doctypes = this.data.doctypes;
    return doctypes[doctypePropName] || doctypes.all;
  }

  /**
   * 種別名の取得
   * @param {String} doctypePropName 種別プロパティ名
   * @return {String} ページの言語に沿った種別名
   */
  getDoctypeLabel(doctypePropName) {
    const doctype = this.getDoctype(doctypePropName);
    return doctype.label[this.lang] || doctype.label['ja'];
  }

  /**
   * 表示用種別情報を取得
   * @param {String} disclosureCode 種別id
   * @return {Object} 表示用種別情報
   */
  getDoctypeInfoByDisclosureCode(disclosureCode) {
    const info = {
      doctypeLabel: '',
      iconClass: ''
    };

    // 種別設定の中から種別idを含んでいるものを探して情報を取得
    const doctypeCode = parseInt(disclosureCode, 10);
    const doctypes = this.getDoctypes();
    for (const doctypePropName of Object.keys(doctypes)) {
      const doctype = doctypes[doctypePropName];
      if (doctype.ids.indexOf(doctypeCode) !== -1) {
        info.doctypeLabel = this.getDoctypeLabel(doctypePropName);
        info.iconClass = ' ' + doctype.iconClass;
        break;
      }
    }

    return info;
  }
}

const IRNEWS_CONFIG = new IRNewsConfig(config);

export default IRNEWS_CONFIG
